'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

interface SubmitButtonProps {
  count?: number | string
  children?: ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export function SubmitButton({ count, children, onClick, disabled, className }: SubmitButtonProps) {
  return (
    <button type="button" className={cx('st-submit-btn', className)} disabled={disabled} onClick={onClick}>
      {count != null && <span className="pip">{count}</span>}
      {children}
    </button>
  )
}
